import { Component, Input, OnInit } from '@angular/core';
import { PlatformEnum, PlatformService } from '@panamax/app-state';
import { BehaviorSubject } from 'rxjs';
import Swiper from 'swiper';
import {
  getSellerCarouselVideos,
  VideoModel,
} from '@product-detail/utils/product-videos-util';
import { ProductSummary } from '@usf/product-types';

@Component({
  selector: 'app-seller-detail-carousel-videos',
  templateUrl: 'seller-detail-carousel-videos.component.html',
  styleUrls: ['seller-detail-carousel-videos.component.scss'],
})
export class SellerDetailCarouselVideosComponent implements OnInit {
  @Input() product: ProductSummary;
  recentSwiperRef$: BehaviorSubject<Swiper> = new BehaviorSubject(null);
  carouselVideos: VideoModel[];

  constructor(readonly platformService: PlatformService) {}

  ngOnInit() {
    this.carouselVideos = [];
    this.setSlideContent();
  }

  setSlideContent(): void {
    this.carouselVideos = getSellerCarouselVideos(this.product);
  }

  setSwiperInstance(swiper: Swiper) {
    this.recentSwiperRef$.next(swiper);
  }

  beforeMainInit(swiper: Swiper) {
    const noSwipingSelector =
      this.platformService?.platformType === PlatformEnum.desktop
        ? 'app-usf-video-player'
        : '.vjs-control-bar';
    swiper.params.noSwipingSelector = noSwipingSelector;
  }
}
